import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import { templateEditorMessages } from '../../config';
import { EditorButton } from '../EditorButton';

import styles from './EditorHistory.module.scss';

type EditorHistoryProps = {
  canUndo: boolean;
  canRedo: boolean;
  className?: string;
  onUndo: () => void;
  onRedo: () => void;
};

export const EditorHistory: FC<EditorHistoryProps> = (props) => {
  const { canUndo, canRedo, className, onUndo, onRedo } = props;

  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(styles.container, className)}
      data-component="template-editor-history"
    >
      <EditorButton
        variant="icon"
        className={styles.button}
        title={formatMessage(templateEditorMessages.undoButton)}
        disabled={!canUndo}
        onClick={onUndo}
      >
        <Icon name="editorUndo" size={22} />
      </EditorButton>
      <EditorButton
        variant="icon"
        className={styles.button}
        title={formatMessage(templateEditorMessages.redoButton)}
        disabled={!canRedo}
        onClick={onRedo}
      >
        <Icon name="editorRedo" size={22} />
      </EditorButton>
    </div>
  );
};
